import { Query, useQuery } from '@burnsred/entity-duck-query';

import {
  Checkbox,
  DefaultErrorBoundary,
  InputWidget,
  TextareaWidget,
  Wrapper,
} from '@/forms';
import { settings } from '@/settings';
import { store } from '@/store';

export default {
  settings,
  store,
  component_errorBoundary: DefaultErrorBoundary,
  component_label: Wrapper,
  component_query: Query,
  hook_useQuery: useQuery,

  widget_boolean: Checkbox,
  // widget_checkbox: WidgetCheckbox,
  widget_char: InputWidget,
  widget_text: TextareaWidget,
  // widget_integer: InputWidget,
  // widget_number: InputWidget,
  // widget_date: DatePicker,
  // widget_datetime: DatePicker,
  // widget_time: DatePicker,
};
